import React, { Component } from 'react';

import { Provider, connect } from 'react-redux';
import { HistoryRouter as Router } from 'redux-first-history/rr6';

import Main from '_environment/Main';

export default function Root({ history, store }) {
    return (
        <Provider store={store}>
            <Router history={history}>
                <Main />
            </Router>
        </Provider>
    )
}